import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import { useNavigate, Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { useLang, setLanguage } from '../../_metronic/i18n/Metronici18n'
import {useThemeMode, ThemeModeType} from '../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

import { MenuComponent } from '../../_metronic/assets/ts/components'

import {useAuth} from '../context/auth'

import { chatAPI } from '../api'

import { ConfirmModal } from './ConfirmModal'

import { UserType } from '../models';

const UserMenuDropdown = ({isFromAdminPage=false}) => {

  const intl = useIntl()

  const selectedLang = useLang()

  const {currentUser} = useAuth()

  const {mode, updateMode} = useThemeMode()

  const navigate = useNavigate()

  const isMobile = useMediaQuery({ maxWidth: 991.98 });

  const [showDeleteAllChatsModal, setShowDeleteAllChatsModal] = useState<boolean>(false)

  const modes: [ThemeModeType, string][] = [
    ['light', 'night-day'],
    ['dark', 'moon']
  ]

  useEffect (() => {
    MenuComponent.createInstances('.user-menu-dropdown')
  }, [])

  const signOut = () => {
    navigate('/a/sign-out')
  }

  const handleDeleteAllChats  = () => {
    chatAPI.deleteAll().then(() => {
      navigate(`/c`, {replace: true, state: {allChatsDeleted: true}})
      setShowDeleteAllChatsModal(false)
    })
  }

  return (
    <>
    <div 
      className="user-menu-dropdown menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-2 fs-6 w-200px" 
      data-kt-menu="true">
      { currentUser?.email &&
      <>
        <div className="menu-item px-3">
          <div className="menu-content d-flex align-items-center px-4">
            <div className="fw-semibold text-muted fs-7">
              {currentUser && currentUser.email}
            </div>
          </div>
        </div>
        { !isFromAdminPage && (
          <>
            <div className="separator my-2"></div>
        
            <div className="menu-item px-2">
              <a className="menu-link px-5 chat-delete-all-btn" onClick={()=>setShowDeleteAllChatsModal(true)}>
                {intl.formatMessage({id: 'chat.delete_all'})}
              </a>
            </div>
          </>
        )}
        <ConfirmModal show={showDeleteAllChatsModal} handleConfirm={handleDeleteAllChats} handleClose={() => setShowDeleteAllChatsModal(false)}/>
        <div className="separator my-2"></div>
      </>
      }
  
      <div className="menu-item px-2" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement={`${isMobile ? 'top-end' : 'left-start'}`} >
        <a className="menu-link px-5">
          <span className="menu-title position-relative">
            {intl.formatMessage({id: 'general.mode.title'})}
            <span className="ms-5 position-absolute translate-middle-y top-50 end-0">
              <i className="theme-light-show fa-solid fa-sun fs-3"></i>
              <i className="theme-dark-show fa-solid fa-moon fs-3"></i>
            </span>
          </span>
        </a>
        <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px" data-kt-menu="true" data-kt-element="theme-mode-menu">
          {modes.map(([mode_, iconName]) => (
          <div className="menu-item px-3 my-0" key={mode_}>
            <a className={`menu-link px-3 py-2 ${mode == mode_ && 'active'}`} onClick={()=>updateMode(mode_)}>
              <span className="menu-icon" data-kt-element="icon">
                <i className={`fa-solid fa-${iconName == 'moon' ? iconName : iconName == 'screen' ? 'display' : 'sun'} fs-2`}></i>
              </span>
              <span className="menu-title">
                {intl.formatMessage({id: 'general.mode.'+mode_})}
              </span>
            </a>
          </div>
          ))}
        </div>
      </div>
        
      <div className="menu-item px-2" >
        <a className="menu-link px-5">
          <span className="menu-title position-relative" onClick={()=>setLanguage(selectedLang === 'ar' ? 'en' : 'ar')}>
            {intl.formatMessage({id: 'general.language'})}
            <span className="ms-5 position-absolute translate-middle-y top-50 end-0">
              {intl.formatMessage({id: `general.language_name.${selectedLang === 'ar' ? 'EN' : 'AR'}`})}
            </span>
          </span>
        </a>
      </div>
  
      { !isFromAdminPage && (
        <>
          <div className="separator my-2"></div>
          <div className="menu-item px-2">
            <a href={`https://fanar.qa/${selectedLang}`} target="_blank" className="terms-btn menu-link px-5">
              {intl.formatMessage({id: 'general.about'})}
            </a>
          </div>
          <div className="menu-item px-2">
            <a href={'#terms-of-service'} className="terms-btn menu-link px-5">
              {intl.formatMessage({id: 'general.terms'})}
            </a>
          </div>
          <div className="menu-item px-2">
            <a href={'#privacy-policy'} className="terms-btn menu-link px-5">
              {intl.formatMessage({id: 'general.privacy'})}
            </a>
          </div>
        </>
      )}
      { currentUser?.email &&
          <>
          <div className="separator my-2"></div>
      
          <div className="menu-item px-2">
            <a onClick={signOut} className="menu-link px-5">
              {intl.formatMessage({id: 'user.sign_out'})}
            </a>
          </div>

          { !isFromAdminPage && (
          <div className="menu-item px-2">
            <Link to='/delete-account' className="menu-link px-5 text-danger">
              {intl.formatMessage({id: 'user.delete_account.title'})}
            </Link>
          </div>
          )}
        </>
      }
      </div>
    </>
  )
}

  
export {UserMenuDropdown}
  